import { PHONE_NUMBER_VALIDATOR } from '@constants';
import { ValidationResult } from 'hooks';

export const validatePhoneNumber = (phoneNumber: string): ValidationResult => {
  const result = {
    isValid: true,
    error: ''
  };

  const isValid = PHONE_NUMBER_VALIDATOR.test(String(phoneNumber));
  if (!isValid) {
    result.error = 'Invalid phone number';
    result.isValid = false;
  }

  return result;
};
